import React from "react";
import Context from "../../../../context";
import { CustomView, CustomModal, CustomButton2 } from "../../../../components";

import "./index.scss";
import ImageViewer from "../../../../components/ImageViewer";
import { useTranslation } from "react-i18next";

const ApproveDocuments = () => {
  const {
    showModal,
    setShowModal,
    isLoading,
    selectedDriver,
    approveDocumentsFunction,
  } = React.useContext(Context.DriverScreen);

  // const nationalCardFront = selectedDriver?.driverInformation?.documents.find(
  //   (item: any) => item.name === "nationalCard"
  // );
  // const nationalCardBack = selectedDriver?.driverInformation?.documents.find(
  //   (item: any) => item.name === "nationalCardBack"
  // );
  // const driverLicense = selectedDriver?.driverInformation?.documents.find(
  //   (item: any) => item.name === "driverLicence"
  // );
  // const carCardFront = selectedDriver?.driverInformation?.documents.find(
  //   (item: any) => item.name === "carCard"
  // );
  // const carCardBack = selectedDriver?.driverInformation?.documents.find(
  //   (item: any) => item.name === "carCardBack"
  // );
  // const checkBackground = selectedDriver?.driverInformation?.documents.find(
  //   (item: any) => item.name === "checkBackground"
  // );
  // const insurance = selectedDriver?.driverInformation?.documents.find(
  //   (item: any) => item.name === "insurance"
  // );

  const { t } = useTranslation();

  // ?? ===========================================================================================================
  // ??                                              JSX Content
  // ?? -----------------------------------------------------------------------------------------------------------
  return (
    <section id="driver-approve-modal-container">
      <CustomModal
        onClose={() => setShowModal!("NONE")}
        open={showModal === "APPROVE_DOCUMENTS"}
        minWidth={"45rem"}
        maxWidth={"55rem"}
        maxHeight={"85vh"}
      >
        <CustomView.Row className="documents-container">
          <CustomView.Column medium={4}>
            <label className="form-label">
              {t("nationalCardFrontImage")} :
            </label>
            <ImageViewer
              imageUrl={
                selectedDriver?.schoolDriverInformation?.documents
                  ?.nationalCardFront
              }
            />
          </CustomView.Column>
          <CustomView.Column medium={4}>
            <label className="form-label">{t("nationalCardBackImage")} :</label>
            <ImageViewer
              imageUrl={
                selectedDriver?.schoolDriverInformation?.documents
                  ?.nationalCardBack
              }
            />
          </CustomView.Column>
          <CustomView.Column medium={4}>
            <label className="form-label">{t("carCardFrontImage")} :</label>
            <ImageViewer
              imageUrl={
                selectedDriver?.schoolDriverInformation?.documents?.carCardFront
              }
            />
          </CustomView.Column>
          <CustomView.Column medium={4}>
            <label className="form-label">{t("nationalCardBackImage")} :</label>
            <ImageViewer
              imageUrl={
                selectedDriver?.schoolDriverInformation?.documents?.carCardBack
              }
            />
          </CustomView.Column>
          <CustomView.Column medium={4}>
            <label className="form-label">{t("nationalCardBackImage")} :</label>
            <ImageViewer
              imageUrl={
                selectedDriver?.schoolDriverInformation?.documents?.insurance
              }
            />
          </CustomView.Column>
          <CustomView.Column medium={4}>
            <label className="form-label">{t("backBackgroundImage")} :</label>
            <ImageViewer
              imageUrl={
                selectedDriver?.schoolDriverInformation?.documents
                  ?.checkBackground
              }
            />
          </CustomView.Column>
          <CustomView.Column medium={4}>
            <label className="form-label">{t("nationalCardBackImage")} :</label>
            <ImageViewer
              imageUrl={
                selectedDriver?.schoolDriverInformation?.documents
                  ?.driverLicence
              }
            />
          </CustomView.Column>
        </CustomView.Row>
        <CustomView.Row className="form-row">
          <CustomView.Column
            large={3}
            medium={4}
            small={6}
            className="form-colum"
          >
            <CustomButton2
              isLoading={isLoading}
              onClick={() => setShowModal!("NONE")}
              title={t("cancel")}
              type="danger"
            />
          </CustomView.Column>
          <CustomView.Column
            large={3}
            medium={4}
            small={6}
            className="form-colum"
          >
            <CustomButton2
              isLoading={isLoading}
              onClick={() => approveDocumentsFunction!(selectedDriver?._id)}
              title={t("approve")}
            />
          </CustomView.Column>
        </CustomView.Row>
      </CustomModal>
    </section>
  );
};

export default ApproveDocuments;
